module.exports = __webpack_public_path__ + "img/logo.3ee5ab57.png";